import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase/firebase";

export async function loadAssignmentProgress({ studentUid, packetId }) {
  if (!studentUid || !packetId) return null;

  const ref = doc(db, "users", studentUid, "assignments", packetId);
  const snap = await getDoc(ref);

  if (!snap.exists()) return null;
  return snap.data();
}
